export const ANAND_TOKEN_ADDRESS = "0x1b4A74e55b9CA13756196c1D3991E08BFb42f829"
export const ANAND_TOKEN_DECIMALS = 18
export const ANAND_PRICE = 0.50
export const TOKENS = ['USDT', 'USDC'];